import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers, { endpoint }) => {
    const token = localStorage.getItem("authtoken") || sessionStorage.getItem("authtoken");

    // Only add token for authenticated endpoints
    if (token && endpoint !== "getTheme") {
      headers.set("Authorization", `Bearer ${token}`);
    }
    
    return headers;
  },
});

export const themeApi = createApi({
  reducerPath: "themeApi",
  baseQuery,
  endpoints: (builder) => ({
    getTheme: builder.query({
      query: () => "/custom_ui/custom-ui-get/",
    }),
    updateTheme: builder.mutation({
      query: (themeData) => ({
        url: "/custom_ui/custom-ui/",
        method: "POST",
        body: themeData,
      }),
    }),
  }),
});

export const { useGetThemeQuery, useUpdateThemeMutation } = themeApi;
